import React, { useState } from "react";

export const LotteryBall = ({ refEl, marker, placeholder }: { refEl: React.LegacyRef<HTMLInputElement>, marker?: boolean, placeholder:string }) => {
    const [value, setValue] = useState<number | string>("")

    const handleChange = (event: any) => {
        const { value } = event.target;
        const newvalue = value.replace(/[^0-9]/g, "").slice(0,2)
        console.log({newvalue})
        setValue(newvalue === "" ? newvalue : Number(newvalue));
    }
    return (
        <div className={`lottery__ball ${value.toString.length && "active"}`} data-marker={marker} >
            <input
                ref={refEl}
                placeholder={placeholder} maxLength={2}
                className={`lottery__ball--input`}
                value={value}
                onChange={handleChange}
                type="text"
            />
        </div>
    )
}